import { useState } from 'react';
import { api, ApiError } from '../api';
import { useSession } from '../session';
import { AuthShell } from '../Brand';

/** Imported trainees arrive without a password; TalentLMS does not export them. */
export function SetPassword() {
  const { refresh, signOut } = useSession();
  const [pw, setPw] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw !== again) return setError('The two passwords are different.');
    setBusy(true); setError(null);
    try {
      await api.post('/auth/password', { newPassword: pw });
      await refresh();
    } catch (err) {
      setError((err as ApiError).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <form className="gate__card" onSubmit={submit}>
        <h1 className="gate__title">Choose your password</h1>
        <p className="gate__sub">One more step before your courses: a password that only you know.</p>

        <label htmlFor="pw">New password</label>
        <input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" minLength={8} required autoFocus />

        <label htmlFor="again">Type it again</label>
        <input id="again" type="password" value={again} onChange={(e) => setAgain(e.target.value)} autoComplete="new-password" required />

        {error && <p className="auth__error" role="alert">{error}</p>}
        <button className="btn btn--primary btn--block" disabled={busy}>{busy ? 'Saving…' : 'Save and continue'}</button>
        <button type="button" className="gate__link link-plain" onClick={() => void signOut()}>Sign out</button>
      </form>
    </AuthShell>
  );
}
